<template>
  <v-container>
    <h1 class="mb-5">Declined Withdrawals</h1>
    <user-details-min :userId="minUserId" :open.sync="openMin" />
    <v-row>
      <v-col>
        <v-card flat color="white">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search..."
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="arrangedTransaction"
            :loading="loadingTransaction"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, 25, 50]
            }"
            @update:items-per-page="updateItemPerPage"
            @update:page="updatePage"
            :server-items-length="apiData.total"
          >
            <template v-slot:[`item.user`]="{ item }">
              <!-- <router-link
                :to="{ name: 'ViewUser', params: { id: item.user_id } }"
                class="font-weight-medium text-capitalize d-block"
                >{{ item.user }}</router-link
              > -->
              <span
                class="font-weight-medium cursor-pointer primary--text text-capitalize d-block"
                @click="openMinDialog(item.user_id)"
              >
                {{ item.user }}
              </span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-card
                :color="
                  item.status == 'approved'
                    ? 'success'
                    : item.status == 'pending'
                    ? 'warning'
                    : 'error'
                "
                flat
                rounded="md"
                outlined
                class="text-capitalize text-center white--text pa-1"
              >
                {{ item.status }}
              </v-card>
            </template>
            <template v-slot:[`item.date`]="{ item }">
              <small class="font-weight-medium">{{ item.date }}</small>
            </template>
            <template v-slot:[`item.netAmount`]="{ item }">
              <span
                >{{ item.netAmount }}
                <small class="grey--text text--darken-2">{{
                  item.currencyCode
                }}</small></span
              >
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <span>
                {{ item.amount }}
                <small class="grey--text text--darken-2">{{
                  item.currencyCode
                }}</small>
              </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn small depressed @click.stop="selectTransaction(item)"
                >View Details</v-btn
              >
              <v-btn
                v-if="canReverse(item)"
                small
                depressed
                color="warning"
                class="ml-2"
                @click.stop="confirmReverse(item)"
                >Reverse</v-btn
              >
              <v-chip v-else-if="item.refunded" small class="ml-2"
                >Reversed</v-chip
              >
            </template>
          </v-data-table>
          <!-- <delete-dialog :open.sync="dialogDelete" type="sales" /> -->
          <withdraw-details
            :open.sync="transactionOpen"
            :transaction="transaction"
          />
          <v-dialog v-model="reverseOpen" max-width="420" persistent>
            <v-card>
              <v-card-title class="text-h6">Reverse withdrawal</v-card-title>
              <v-card-text>
                Refund
                <strong
                  >{{ reverseTarget.netAmount }}
                  {{ reverseTarget.currencyCode }}</strong
                >
                back to
                <strong class="text-capitalize">{{
                  reverseTarget.user
                }}</strong
                >'s wallet? This cannot be undone.
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="reversing" @click="reverseOpen = false"
                  >Cancel</v-btn
                >
                <v-btn
                  color="warning"
                  depressed
                  :loading="reversing"
                  @click="reverseTransaction"
                  >Reverse</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import DeleteDialog from '../../../components/deleteDialog.vue'
import withdrawDetails from '../../../components/withdrawDetails.vue'
import withdrawalApi from '../../../api/admin/withdrawals'
import { numberWithCommas } from '../../../utils/helpers'
import UserDetailsMin from '../../../components/userDetailsMin.vue'
import _ from 'lodash'

export default {
  components: {
    withdrawDetails,
    UserDetailsMin
    //  DeleteDialog
  },
  data: () => ({
    openMin: false,
    minUserId: '',
    search: '',
    transactionOpen: false,
    dialogDelete: false,
    reverseOpen: false,
    reversing: false,
    reverseTarget: {},
    headers: [
      {
        text: 'Date',
        align: 'start',
        value: 'date'
      },
      {
        text: 'Username',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Net Amount',
        value: 'netAmount'
      },
      {
        text: 'Price',
        value: 'amount'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: '',
        value: 'action',
        sortable: false
      }
    ],
    transactions: [],
    transaction: {},
    perPage: 10,
    loadingTransaction: false,
    apiData: {},
    lastPage: 1,
    progress: 'starting'
  }),
  created() {
    this.getTransactions(0)
    this.debounceSearch = _.debounce(this.searchData, 500)
  },
  watch: {
    search(newValue) {
      if (newValue === '') {
        this.getTransactions(0)
        return
      }
      this.debounceSearch()
    }
  },
  computed: {
    arrangedTransaction() {
      if (this.transactions.length !== []) {
        return this.transactions.map((transaction) => ({
          ...transaction,
          id: transaction._id,
          date: new Date(
            transaction.created_at
              ? transaction.created_at
              : transaction.createdAt
          ).toDateString(),
          user: transaction.user.username,
          user_id: transaction.user._id,
          status: transaction.status,
          netAmount: numberWithCommas(transaction.net_amount),
          amount: numberWithCommas(transaction.amount)
        }))
      }
      return []
    }
  },
  methods: {
    canReverse(item) {
      return (
        !item.refunded &&
        (item.status === 'declined' || item.paymentStatus === 'failed')
      )
    },
    confirmReverse(item) {
      this.reverseTarget = item
      this.reverseOpen = true
    },
    async reverseTransaction() {
      this.reversing = true
      const res = await withdrawalApi.logs().reverse(this.reverseTarget.id)
      this.reversing = false
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          error: true,
          status: true
        })
        return
      }
      this.$store.dispatch('alert', {
        message: 'Withdrawal reversed and refunded to wallet',
        error: false,
        status: true
      })
      this.reverseOpen = false
      this.getTransactions((this.lastPage - 1) * this.perPage)
    },
    openMinDialog(id) {
      this.openMin = true
      this.minUserId = id
    },
    updatePage(page) {
      if (this.lastPage - page > 2) {
        page = this.lastPage
      }
      this.lastPage = page
      this.getTransactions((page - 1) * this.perPage)
    },
    updateItemPerPage(count) {
      this.perPage = count
      this.getTransactions((this.lastPage - 1) * this.perPage)
    },
    async searchData() {
      this.loadingTransaction = true
      this.transactionsM = []
      const res = await withdrawalApi.logs().getAll({
        status: 'declined',
        populate: ['user', 'method', 'actionby'],
        limit: this.perPage,
        keyword: this.search
      })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          error: true,
          status: true
        })
        return
      }
      this.transactions = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    async getTransactions(length) {
      const res = await withdrawalApi.logs().getAll({
        status: 'declined',
        populate: ['user', 'method', 'actionby'],
        limit: this.perPage,
        offset: length
      })

      this.transactions = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    selectTransaction(transx) {
      const transaction = this.transactions.find((trx) => trx._id === transx.id)

      this.transaction = {
        ...transaction,
        date: new Date(
          transaction.created_at
            ? transaction.created_at
            : transaction.createdAt
        ).toDateString(),
        time: new Date(
          transaction.created_at
            ? transaction.created_at
            : transaction.createdAt
        ).toTimeString(),
        status: transaction.status,
        email: transaction.user.email,
        username: transaction.user.username,
        transactionInfo: [
          {
            title: 'Transaction Type',
            text: `Withdrawal`
          },
          {
            title: 'Withdrawal Method',
            text: transaction.method ? transaction.method.name : ''
          },
          {
            title: 'Amount',
            text: `${transaction.amount} NGN`
          },
          {
            title: 'Withdrawal Charge',
            text: `${numberWithCommas(transaction.charge)} ${
              transaction.currencyCode
            }`
          },
          {
            title: 'Total Amount',
            text: `${numberWithCommas(transaction.net_amount)} ${
              transaction.currencyCode
            }`
          },
          {
            title: 'TRX ID',
            text: `${transaction.transaction_id}`
          }
        ],
        transactionDetails: [
          {
            title: 'Payment Methods',
            text: transaction.method ? transaction.method.name : ''
          },
          {
            title: `Reason for Decline`,
            text: `${transaction.message ? transaction.message : ''}`
          },
          {
            title: `Image for Decline`,
            text: `${
              transaction.declineImage
                ? transaction.declineImage
                : 'No image uploaded'
            }`
          },
          {
            title: 'Amount To Pay',
            text: `${transaction.amount} ${transaction.currencyCode}`
          },
          {
            title: 'Action By',
            text: `${
              transaction.actionby ? transaction.actionby.name : 'admin'
            }`
          },
          {
            title: 'Declined At',
            text: transaction.actionedAt
              ? new Date(transaction.actionedAt)
              : 'No approved date/time provided'
          }
        ]
      }
      this.transactionOpen = true
    }
  }
}
</script>

<style></style>
